import { lazy, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useAppDispatch, useAppSelector } from '../../../app/hooks'
import { setCurrentModal } from '../../../app/reducers/modal/modal.slice'
import { ModalsTypesEnum } from '../../../app/reducers/modal/modal.types'
import { INewsItem } from '../../../app/reducers/news/news.slice'
import { Button } from '../../UI/Button'
import Container from '../Container/Container'
import SectionTitle from '../SectionTitle/SectionTitle'
import ColoredDate from './Date'
import ImageNewsItem from './ImageNewsItem'
import styles from './News.module.scss'
import NewsItem from './NewsItem'

const Modal = lazy(() => import('../../Modal'))

const News = () => {
	const { t, i18n } = useTranslation()
	const { news } = useAppSelector(state => state.news)
	const [current, setCurrent] = useState<INewsItem>({} as INewsItem)
	const { currentModal } = useAppSelector(state => state.modal)
	const dispatch = useAppDispatch()

	const openNewsItem = (item: INewsItem) => {
		setCurrent(item)
		dispatch(setCurrentModal(ModalsTypesEnum.NEWS_ITEM))
	}

	return (
		<>
			<div className={styles.wrapper} id='news'>
				<Container>
					<div className={styles.header}>
						<SectionTitle
							text={t('landing.news.title')}
							gradientText='Sairus'
							className={styles.title}
						/>
						<Button
							text={t('landing.news.btn')}
							color='cian'
							className={styles.btn}
							onClick={() => {
								dispatch(setCurrentModal(ModalsTypesEnum.NEWS))
							}}
						/>
					</div>
					<div className={styles.body}>
						<div className={styles.mainNews}>
							{news[4] && (
								<ImageNewsItem
									newsItem={news[4]}
									onClick={() => openNewsItem(news[4])}
									isOpen={false}
								/>
							)}
							<Button
								text={t('landing.news.btn')}
								color='cian'
								className={[styles.btn, styles.smBtn].join(' ')}
								onClick={() => {
									dispatch(setCurrentModal(ModalsTypesEnum.NEWS))
								}}
							/>
						</div>
						<div className={styles.newsItems}>
							{news[2] && (
								<NewsItem
									newsItem={news[2]}
									onClick={() => openNewsItem(news[2])}
								/>
							)}
							{news[3] && (
								<NewsItem
									newsItem={news[3]}
									onClick={() => openNewsItem(news[3])}
								/>
							)}
							<Button
								text={t('landing.news.btn')}
								color='cian'
								className={[styles.btn, styles.xsBtn].join(' ')}
								onClick={() => {
									dispatch(setCurrentModal(ModalsTypesEnum.NEWS))
								}}
							/>
						</div>
					</div>
				</Container>
			</div>
			<Modal
				open={currentModal === ModalsTypesEnum.NEWS}
				style={{ zIndex: 9002 }}
				className={styles.modal}
			>
				<div className={styles.modalContent}>
					{news.map((item, i) => (
						<ImageNewsItem
							newsItem={item}
							key={i}
							onClick={() => openNewsItem(item)}
							isOpen={true}
						/>
					))}
				</div>
			</Modal>
			<Modal
				open={currentModal === ModalsTypesEnum.NEWS_ITEM}
				style={{ zIndex: 9002 }}
				className={styles.modal}
			>
				<div className={styles.newsModal}>
					<span
						className={[styles.link, styles.back].join(' ')}
						onClick={() => dispatch(setCurrentModal(ModalsTypesEnum.NEWS))}
					>
						<i>←</i> <b>{t('modals.back')}</b>
					</span>
					<h3>{current.title}</h3>
					<ColoredDate date={current.published} />
					<img src={current.imageUrl} alt={current.title} />
					<div
						className={styles.newsModalText}
						dangerouslySetInnerHTML={{ __html: current.content }}
					></div>
				</div>
			</Modal>
		</>
	)
}

export default News
